/* Outdoors Nordic. Flyttad ur snippets/on-counter-body.liquid 2026-10-07.
   Lag inline och skickades med varje sidvisning som anvande sektionen.
   Laddas som modul: samma URL evalueras en gang oavsett antal taggar. */
(function () {
if (window.__onCtrInit) { document.dispatchEvent(new CustomEvent('on-ctr:rescan')); return; }
window.__onCtrInit = true;
var lugn = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
/* Talet är redan färdigskrivet i HTML:en. Uppräkningen får därför bara byta
ut siffrorna, aldrig räkna ut vad slutvärdet ska vara - annars hade en
besökare med JS kunnat se ett annat tal än en utan. */
function formatera(n, grp) {
var s = String(Math.round(n));
var ut = '';
for (var i = 0; i < s.length; i++) {
 if (i > 0 && (s.length - i) % 3 === 0) ut += grp;
 ut += s[i];
}
return ut;
}
function rakna(el) {
if (el.getAttribute('data-ctr-done') === '1') return;
el.setAttribute('data-ctr-done', '1');
var mal = parseFloat(el.getAttribute('data-ctr-to'));
if (!isFinite(mal) || mal <= 0) return;
var grp = el.getAttribute('data-ctr-grp') || ' ';
var suf = el.getAttribute('data-ctr-suf') || '';
if (lugn) return;
 /* Korta tal ska inte ta lika lång tid som långa: 4 räknas klart långt
  innan 90 634 hinner bli läsbart. */
var tid = mal < 100 ? 900 : 1600;
var start = 0;
var klar = false;
 function slutfor() {
 if (klar) return;
 klar = true;
 el.textContent = formatera(mal, grp) + suf;
}
 function steg(nu) {
 if (klar) return;
 if (!start) start = nu;
 var p = Math.min((nu - start) / tid, 1);
 if (p >= 1) { slutfor(); return; }
 var e = 1 - Math.pow(1 - p, 3);
 el.textContent = formatera(mal * e, grp) + suf;
 requestAnimationFrame(steg);
}
requestAnimationFrame(steg);
 /* requestAnimationFrame fryser helt i en dold flik och aterupptas inte
  alltid dar den slutade. Utan den har vakten star siffran kvar pa ett
  halvvagsvarde - 89 387 i stallet for 90 634 - och ser ut som butikens
  riktiga siffra. Timern gar ocksa trogare i bakgrunden, men den kommer,
  och da hoppar talet till sitt slutvarde. */
setTimeout(slutfor, tid + 800);
}
function koppla(root) {
var list = (root && root.querySelectorAll ? root : document).querySelectorAll('.on-ctr__num:not([data-ctr-bound])');
for (var i = 0; i < list.length; i++) {
 var el = list[i];
 el.setAttribute('data-ctr-bound', '1');
 if (!('IntersectionObserver' in window)) { rakna(el); continue; }
 obs.observe(el);
}
}
var obs = ('IntersectionObserver' in window)
? new IntersectionObserver(function (poster) {
   poster.forEach(function (p) {
     if (p.isIntersecting) { rakna(p.target); obs.unobserve(p.target); }
   });
 }, { threshold: 0.4 })
: null;
if (document.readyState !== 'loading') koppla(document);
else document.addEventListener('DOMContentLoaded', function () { koppla(document); });
document.addEventListener('shopify:section:load', function (e) { koppla(e.target || document); });
document.addEventListener('on-ctr:rescan', function () { koppla(document); });
  })();

